import React, { useEffect, useState } from 'react';
import { addHours, getDate, getDay, getMonth } from "date-fns"
import { monthNumber, simpleDateBR, simpleDateUS } from "../../../../../../utils/date";
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { Form } from '@unform/web';
import SelectSimple from '../../../../core/components/Forms/SelectSimple';
import Chart from '../../../../../../components/ChartModule';
import { FaCalendar, FaChartBar, FaChartPie, FaCheck, FaCreditCard, FaFilter, FaTicketAlt } from 'react-icons/fa';
import CheckboxInput from '../../../../../../components/Forms/CheckboxInputSearch';
import { useModal } from '../../../../../../hooks/Modal';
import { FiFilter } from 'react-icons/fi';
interface IProps {
    sales?: Array<Record<string, any>>,
    salesProducts?: Array<Record<string, any>>,
    students?: Array<Record<string, any>>,
    products?: Array<Record<string, any>>,
}

interface IOption {
    id: string;
    label: string;
    value: string;
}

const SalesByDay: React.FC<IProps> = ({ sales = [], salesProducts = [], students, products = [] }) => {
    const { addModal, removeModal } = useModal();
    const [chartType, setChartType] = useState('bar');
    const [sortBy, setSortBy] = useState('brDate');
    const [type, setType] = useState('day');

    const [paymentStatus, setPaymentStatus] = useState<Array<string>>([]);
    const [paymentMethod, setPaymentMethod] = useState<Array<string>>([]);


    // Define the target time zone as GMT-3
    const targetTimeZone = 'America/Sao_Paulo'; // Example for GMT-3, adjust as necessary


    const sortByType = [
        { label: 'Data', value: 'brDate' },
        { label: 'Status de pagamento', value: 'payment_status_id' },
        { label: 'Forma de pagamento', value: 'payment_method_id' },
        { label: 'Produto', value: 'product' },
    ]


    const dayType = [
        { label: 'Por dia', value: 'day' },
        { label: 'Por hora', value: 'hour' },
        { label: 'Por mês', value: 'month' },
        { label: 'Por ano', value: 'year' },
    ]

    const payment_status_id = [
        { label: 'Pago', value: 'paid', id: 'paid' },
        { label: 'Aguardando pagamento', value: 'waiting', id: 'waiting' },
    ]

    const payment_method_id = [
        { label: 'Cartão de crédito', value: 'credit_card', id: 'credit_card' },
        { label: 'Boleto', value: 'boleto', id: 'boleto' },
        { label: 'PIX', value: 'pix', id: 'pix' },
        { label: 'Cortesia', value: 'cortesy', id: 'cortesy' },
    ]

    const currentDayType = dayType?.find(item => item?.value === type);







    const typesBR = {
        day: 'dd/MM/yyyy',
        hour: 'HH',
        year: 'yyyy',
        month: 'MM',
    }

    const typesUSA = {
        day: 'yyyy-MM-dd',
        hour: 'HH',
        year: 'yyyy',
        month: 'MM',
    }

    const salesProductsList = sales?.reduce((prev, item) => {



        if (paymentStatus && paymentStatus?.length >= 0 && paymentStatus?.[0]) {
            if (paymentStatus?.findIndex(status => status === item?.payment_status_id) < 0) {
                return prev;
            }
        }

        if (paymentMethod && paymentMethod?.length >= 0 && paymentMethod?.[0]) {
            if (paymentMethod?.findIndex(method => method === item?.payment_method_id) < 0) {
                return prev;
            }
        }

        const dateInTargetTimeZone = utcToZonedTime(item.createdAt, targetTimeZone);

        // Format date to dd/MM/yyyy for dateBr
        let brDate = format(dateInTargetTimeZone, typesBR[type]);



        if (sortBy === 'payment_status_id') {
            brDate = payment_status_id?.find(status => status?.value === item?.payment_status_id)?.label || '';
        }

        if (sortBy === 'payment_method_id') {
            brDate = payment_method_id?.find(method => method?.value === item?.payment_method_id)?.label || '';
        }

        // Format date to yyyy-MM-dd for dateUS
        const date = format(dateInTargetTimeZone, typesUSA[type]);



        //   const index = prev?.findIndex(i => i?.date === date);

        {/*   if (index >= 0) {
            prev[index].count = prev[index].count + 1;
        }
        else {
            prev.push({ date: date, brDate, count: 1 });
        }
    */}
        prev.push({ date: date, brDate, count: 1, total: item.total });
        return prev;

    }, []);



    const sortedList = salesProductsList.sort((a, b) => a.date < b.date ? 1 : a.date > b.date ? -1 : 0);

    const productList = products ? products?.reduce((prev: Array<IOption>, item): Array<IOption> => {
        prev.push({ label: item?.title, value: item?._id?.toString(), id: item?._id?.toString() });
        return prev;
    }, [] as Array<IOption>) : [];



    return <>
        <div className=' full-width' style={{ background: '#eee', padding: '10px 16px', width: '100%' }}>
            <div className=' full-width'>



                <div className='row row-start full-width gap'>

                    <div>
                        <div onClick={() => addModal({
                            theme: 'whiteModalMini',
                            key: 'payment_status_id',
                            title: '', content: <>
                                <Form initialData={{
                                    payment_status_id: paymentStatus
                                }} onSubmit={(data) => { setPaymentStatus(data?.payment_status_id); removeModal('payment_status_id') }}>
                                    <aside style={{ width: '100%', display: 'flex', justifyContent: 'center' }}><button type='submit' style={{ minWidth: '250px' }} className='greenButton2 buttonColored'>Salvar</button> </aside>

                                    <CheckboxInput name='payment_status_id' options={payment_status_id} />
                                    <aside style={{ width: '100%', display: 'flex', justifyContent: 'center' }}><button type='submit' style={{ minWidth: '250px' }} className='greenButton2 buttonColored'>Salvar</button> </aside>
                                </Form>
                            </>
                        })}><button className="greenButton2 buttonColored"><FiFilter /> Status de Pagamento {paymentStatus?.length > 0 ? <aside style={{ padding: '5px', minWidth: '30px', minHeight: '30px', borderRadius: '50%', color: '#c3a257', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{paymentStatus?.length || '0'}</aside> : <></>}</button></div>
                    </div>
                    <div>
                        <div onClick={() => addModal({
                            theme: 'whiteModalMini',
                            key: 'payment_method_id',
                            title: '', content: <>
                                <Form initialData={{
                                    payment_method_id: paymentMethod
                                }} onSubmit={(data) => { setPaymentMethod(data?.payment_method_id); removeModal('payment_method_id') }}>
                                    <aside style={{ width: '100%', display: 'flex', justifyContent: 'center' }}><button type='submit' style={{ minWidth: '250px' }} className='greenButton2 buttonColored'>Salvar</button> </aside>

                                    <CheckboxInput name='payment_method_id' options={payment_method_id} />
                                    <aside style={{ width: '100%', display: 'flex', justifyContent: 'center' }}><button type='submit' style={{ minWidth: '250px' }} className='greenButton2 buttonColored'>Salvar</button> </aside>
                                </Form>
                            </>
                        })}><button className="greenButton2 buttonColored"><FiFilter /> Forma de pagamento {paymentMethod?.length > 0 ? <aside style={{ padding: '5px', minWidth: '30px', minHeight: '30px', borderRadius: '50%', color: '#c3a257', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{paymentMethod?.length || '0'}</aside> : <></>}</button></div>

                    </div>
                </div>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', alignItems: 'center', width: '100%', gap: '20px' }}>
                <div className='borderBlock'>
                    <p style={{ padding: '5px 0px' }}>Agrupar por:</p>
                    <div style={{ width: 'auto', gap: '5px', display: 'flex', minWidth: 'auto' }}>
                        <div title='Período' onClick={() => setSortBy('brDate')} className={sortBy === 'brDate' ? 'greenButton2Mini buttonColored shadow' : 'greenButton2Mini shadow'}>
                            Período
                        </div>

                        <div title='Método de pagamento' onClick={() => setSortBy('payment_method_id')} className={sortBy === 'payment_method_id' ? 'greenButton2Mini buttonColored shadow' : 'greenButton2Mini shadow'}>
                            Forma de pagamento
                        </div>
                        <div title='Status de pagamento' onClick={() => setSortBy('payment_status_id')} className={sortBy === 'payment_status_id' ? 'greenButton2Mini buttonColored shadow' : 'greenButton2Mini shadow'}>
                            Status de pagamento
                        </div>
                    </div>

                </div>
                {sortBy === 'brDate' ? <div className='borderBlock'  >
                    <p style={{ padding: '5px 0px' }}>Período:</p>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'flex-start', alignItems: 'center', width: '100%' }}>
                        {dayType?.map(item => {
                            return <button onClick={() => setType(item?.value)} className={type === item?.value ? 'greenButton2Mini  buttonColored' : 'greenButton2Mini'}>{item?.label}</button>
                        })}


                    </div>


                </div> : <></>}
            </div>
            <div style={{ width: '100%', padding: '10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '3px' }} >

                <div style={{ width: '100%', padding: '10px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '3px', flexWrap: 'wrap' }} >
                    <nav style={{ fontSize: '12px', color: '#333' }}>Filtros</nav>

                    {type ? <nav className='labelTag'>{currentDayType?.label}</nav> : <></>}
                    {paymentStatus ? paymentStatus?.map(status => <nav className='labelTag'>{payment_status_id?.find(item => item?.value === status)?.label}</nav>) : <></>}

                    {paymentMethod ? paymentMethod?.map(method => <nav className='labelTag'>{payment_method_id?.find(item => item?.value === method)?.label}</nav>) : <></>}
                </div>

                <div style={{ width: '100px', gap: '5px', display: 'flex', minWidth: '100px' }}>
                    <div onClick={() => setChartType('bar')} className={chartType === 'bar' ? 'IconBallActive shadow' : 'IconBall shadow'}>
                        <FaChartBar />
                    </div>
                    <div onClick={() => setChartType('pie')} className={chartType === 'pie' ? 'IconBallActive shadow' : 'IconBall shadow'}>
                        < FaChartPie />
                    </div>
                </div>
            </div>
        </div>
        {/*    <table className="table">
            <tr><th>Data</th><th>Vendas</th></tr>
            {sortedList?.map(day => {
                return <tr key={`resumo-vendas-${day?.date}`}><td>{day?.brDate}</td><td>{day?.count}</td></tr>
            })}

        </table> */}

        <Chart sortBy='brDate' showTotal={true} data={sortedList} group={'brDate'} chartType={chartType} />
    </>


}

export default SalesByDay;